import Vuex from 'vuex';
import Vue from 'vue';
import UsersModule from './modules/UsersModule';
import { Decrypt } from '@/utils/crypto.js';
import { getConfig, dictionaries, gerAreas, gerArea, gerCitys, getMenus, getCounties,getCountiesAll } from '@/api/user';
import { getDicList } from '@/api/homePage';
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        users:UsersModule,
    },
    state: {
        // 系统配置
        comfig:null,
        // 行政区数据
        area:[], // 市
        citys:[],   // 省市
        areas: [], //全国省市
        counties: [], // 行政区树菜单
        countiesAll:[],
        // 选中地市
        areaCode:'',
        // 字典
        dict:null,
        _dict: {},
        // 路由列表数据
        addRouters:[],
        navList:[],
        isReset: false
    },
    getters: {
        permissions:state =>{
            const per = Vue.cookie.get('permissions');
            let permissions = {};
            if(per){
                permissions= JSON.parse(Decrypt(per));
            }
            return permissions;
        },
        // 附件轮播图ip
        slideshowIp:state =>{
            let comfig=state.comfig || {};
            return comfig.slideshowIp || '';
        },
        // 诚信监管 jgIp
        jgIp:state =>{
            let comfig=state.comfig || {};
            return comfig.jgIp || '';
        },
        // 项目状态
        projectStatus:state =>{
            let dict=state.dict || {};
            return dict.projectStatus || [];
        },
        // 企业类型
        corpType:state =>{
            let dict=state.dict || {};
            return dict.corpType || [];
        },
        // 项目分类
        projectCatetory:state =>{
            let dict=state.dict || {};
            return dict.projectCatetory || [];
        },
        // 工种类型
        workerType:state =>{
            let dict=state.dict || {};
            return dict.workerType || [];
        },
        _dict(state) {
            return state._dict
        }
    },
    mutations: {
        SetCountiesAll(state,data){
            state.countiesAll=data;
          },
        // 重置 state
        resetState(state){
            state.area = [];
            state.citys = [];
            state.areaCode = '';
            state.dict = null;
            state._dict = {};
            state.addRouters = [];
            state.navList = [];
        },
        // 设置是否需要重置列表页面
        SetReset(state,name){
            state.isReset = name;
        },
        // 设置诚信监管ip
        SetComfig(state,name){
            state.comfig = name;
        },
        // 设置导航菜单
        SetNavList(state,data){
            state.navList = data;
        },
        // 设置动态路由
        SetAddRouters(state,data){
            state.addRouters = data;
        },
        // 设置选中地市
        SetAreaCode(state,name){
            state.areaCode = name;
        },
        // 设置行政区
        SetArea(state,data){
            state.area=data;
        },
        // 设置全国省市
        SetAreas(state,data){
            state.areas=data;
        },
        // 设置行政区树菜单
        SetCounties(state,data){
            state.counties=data;
        },
        // 设置行政区划
        SetCitys(state,data){
            state.citys=data;
        },
        // 设置字典
        SetDict(state,data){
            state.dict=data;
        },
        Set_Dict(state, data) {
            state._dict = data
        }
    },
    actions: {
    // 获取全国菜单
    GetCountiesAll(context,data) {

        return new Promise((resolve, reject) => {
          getCountiesAll(data).then((res)=>{
            context.commit('SetCountiesAll',res.data.data || []);
            // context.commit('SetCounties',res.data.data || []);
            resolve(res);
          }).catch((err)=>{
            reject(err);
          });
  
        });
      },
        // 获取诚信监管ip
        GetComfig(context,data) {
            return new Promise((resolve, reject) => {
                getConfig().then((res)=>{
                    context.commit('SetComfig',res.data.data);
                    resolve(res)
                }).catch((err)=>{
                    reject(err)
                });
            })
        },
        // 获取字典表 /dict/dictionaries
        GetDict(context,data) {
            if(!context.state.dict){
                return new Promise((resolve, reject) => {
                    dictionaries().then((res)=>{
                        if (res.data.success){
                            context.commit('SetDict',res.data.data);
                            resolve(res);
                        }else {
                            reject(res);
                        }

                    }).catch((err)=>{
                        reject(err);
                    });
                })
            }
        },
        Get_Dict(context,data) {
            if(JSON.stringify(context.state._dict) == '{}'){
                return new Promise((resolve, reject) => {
                    getDicList().then((res)=>{
                        // console.log(res, 'store')
                        if (res.status == 200){
                            context.commit('Set_Dict',res.data);
                            resolve(res);
                        }else {
                            reject(res);
                        }
                    }).catch((err)=>{
                        reject(err);
                    });
                })
            }
        },
        // 获取全国省市
        GetAreas(context,data) {
            if(context.state.areas.length===0){
                return new Promise((resolve, reject) => {
                    gerAreas().then((res)=>{
                        context.commit('SetAreas',res.data.data);
                        resolve(res)
                    }).catch((err)=>{
                        reject(err)
                    });
                })
            }
        },
        // 获取行政区树菜单
        GetCounties(context,data) {
            if(context.state.areas.length===0){
                return new Promise((resolve, reject) => {
                    getCounties(data).then((res)=>{
                        context.commit('SetCounties',res.data.data || []);
                        resolve(res)
                    }).catch((err)=>{
                        reject(err)
                    });
                })
            }
        },
        // 获取广东的所有市级别
        GetArea(context,data) {
            if(context.state.area.length===0){
                return new Promise((resolve, reject) => {
                    gerArea({
                        areaCode: localStorage.getItem('tenantAreaCode')
                    }).then((res)=>{
                        // res.data.data.unshift({value: '',label:'广东省'});
                        // res.data.data.unshift({value: '610000',label:'陕西省'});
                        context.commit('SetArea',res.data.data);
                        context.commit('SetAreaCode','');
                        resolve(res)
                    }).catch((err)=>{
                        reject(err)
                    });
                })
            }
        },
        // 获取行政区 广东省和市级别
        GetCitys(context,data) {
            if(context.state.citys.length===0){
                return new Promise((resolve, reject) => {
                    gerCitys({
                        areaCode: localStorage.getItem('tenantAreaCode'),
                    }).then((res)=>{
                        context.commit('SetCitys',res.data.data);
                        resolve(res)
                    }).catch((err)=>{
                        reject(err)
                    });
                })
            }

        },
        // 生成导航路由
        GenerateRoutes(context, data) {
            return new Promise((resolve, reject) => {
                // console.log(context.state.navList);
                if(context.state.navList.length===0){
                    getMenus().then((res)=>{
                        if(res.data.success){
                            if(res.data.data.length == 0){
                                localStorage.setItem('userId','')
                            }
                            context.commit('SetNavList',res.data.data);
                            resolve(res.data.data)
                        }else {
                            reject(err)
                        }
                    }).catch((err)=>{
                        reject(err)
                    });
                }
            })
        }
    }
});
